import React from 'react';
import { t } from 'i18next';
import { CloseButton, CloseButtonColor, CloseButtonSize } from '../../../DesignSystem/LiliCloseButton/CloseButton';
import { LiliTooltip, TooltipPosition, LiliToolTipColor } from '../../../DesignSystem/LiliTooltip/LiliTooltip';

interface IProps {
  openToolTip: boolean;
  setOpenToolTip: (value: boolean) => void;
  allowedStates: string[];
}

export const StatesToolTip = ({ openToolTip, setOpenToolTip, allowedStates }: IProps) => {
  const statesHeader1 = t('INT_WIRE_ALLOWED_STATES_HEADER', 'Supported countries ');
  const statesHeader2 = t('INT_WIRE_ALLOWED_STATES_HEADER', 'for international wire');

  return (
    <div>
      <LiliTooltip
        targetId='states-button'
        position={TooltipPosition.RIGHT}
        color={LiliToolTipColor.White}
        isOpen={openToolTip}
        onClose={() => setOpenToolTip(false)}
        description=''
        customContent={
          <div>
            <div className='p-4'>
              <CloseButton
                onClick={() => setOpenToolTip(false)}
                id='closeButton'
                color={CloseButtonColor.Gray}
                size={CloseButtonSize.Medium}
                className='absolute top-2 right-2 w-[0.625rem] h-[0.625rem] cursor-pointer z-10'
              />
              <div className='text-bw08 text-[14px] w-[200px]'>{statesHeader1}</div>
              <div className='text-bw08 text-[14px] w-[200px]'>{statesHeader2}</div>
            </div>
            <div className=' border-bw03 border w-full' />
            <div className='p-4 overflow-y-scroll'>
              {allowedStates.map((state) => (
                <div key={state} className='text-bw08 text-[14px]'>
                  {state}
                </div>
              ))}
            </div>
          </div>
        }
      />
    </div>
  );
};
